import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store/types/RootState';

type SystemSlice = RootState['systemSlice'];

const selectSystemSlice = (state: RootState) => state?.systemSlice;

export const selectSystemIsLoading = createSelector(selectSystemSlice, (state: SystemSlice) =>
  Boolean(state?.isLoading),
);

export const selectSystemTenantConfig =
  createSelector(selectSystemSlice, (state: SystemSlice) => state.tenantConfiguration) || {};

export const selectSystemTenantConfigurationIsLoading =
  createSelector(selectSystemSlice, (state: SystemSlice) => state.isTenantConfigurationLoading) || false;
